import { BaseCellStyledBox } from './base-cell-styled-box';
import { getClockTime } from '../../../queues/utils/get-clock-time';
import { getFormattedDate } from '../../../queues/utils/get-formatted-date';
import { Tooltip } from '../tooltip';
import { FormattedDurationSince } from '../formatted-duration-since';

export const FrTimeCell = ({ dateStr }: { dateStr: string | undefined }) => {
    if (!dateStr) return null;

    return (
        <BaseCellStyledBox>
            <Tooltip overlay={getFormattedDate(dateStr)}>
                <span>{getClockTime(dateStr)}</span>
            </Tooltip>
        </BaseCellStyledBox>
    );
}

export const FrMinutesCell = ({ dateStr }: { dateStr: string | undefined }) => {
    if (!dateStr) return null;

    return (
        <BaseCellStyledBox>
            <FormattedDurationSince date={new Date(dateStr)} />
        </BaseCellStyledBox>
    );
}
